<template>
  <div id="index">
    <!-- 头部 -->

    <!-- <Hezuo></Hezuo> -->
    <HeaderTop :headIndex="2" :searchText="searchText" ref="header" @searchFun="searchFun"></HeaderTop>
    <!-- 推荐内容 -->
    <div v-if="idloading">
      <div class="spinner-box">
        <img src="@/assets/img/loadding_pc.gif" alt="">
        <div>努力加载中...</div>
      </div>
    </div>
    <div class="main wrap flex_between" v-else>
      <!-- 推荐 -->
      <div class="recommended">
        <div class="flex_between recommended_head">
          <div class="recommended_title">
            <span class="recommended_title_li" v-for="(liem, index) in recommended_arr" :key="index" :class="{ selected: recommended_id == liem.conf_id }" @click.stop="recommendedFun(index)">{{ liem.title }}</span>
          </div>
          <button class="flex_center focus no_focus" @click="follow(2)" v-if="recommended_arr&&recommended_arr[recommended_index].is_follow == 1&&recommended_arr[recommended_index].conf_id != 0">
            取消关注
          </button>
          <button class="flex_center focus" @click="follow(1)" v-if="recommended_arr&&recommended_arr[recommended_index].is_follow == 0&&recommended_arr[recommended_index].conf_id != 0">
            关注此栏目
          </button>
        </div>
        <div class="liem_ul">
          <listLi :list_arr="list_arr" ref="listLi" :is_loading="is_loading" @detailsFun="detailsFun">
          </listLi>
          <div class="complete" v-if="is_more && list_arr.length > 0" @click="moreFun">
            点击加载更多
          </div>
        </div>
      </div>
      <!-- 热门 -->
      <div class="hot_div hot">
        <div class="hot_title flex_center">
          <i><img src="@/assets/img/hot.png" alt="" /></i>
          <span class="flex_center">热门</span>
        </div>
        <div class="">
          <hot :list="hotList_arr" @detailsFun="detailsFun"></hot>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
import Footer from "@/components/assembly/Footer.vue"; //尾部模块
import hot from "@/components/assembly/hot.vue"; //热门模块
import listLi from "@/components/assembly/listLi.vue"; //列表数据模块
import "@/assets/js/swiper.animate1.0.3.min.js";
// import "@/assets/js/wx_jsapi.js";
import wx from "weixin-js-sdk";
import Hezuo from '@/components/tool/hezuo.vue'

import "@/assets/js/currency.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/reset.css";

//pc端
// import "@/assets/css/index_min768.css";

export default {
  name: "column",
  data() {
    return {
      IMG_URL: this.$IMG_URL,
      recommended_id: 0, //导航 index
      recommended_arr: [], //导航列表
      recommended_index: 0, //

      page: 1, //翻页
      list_arr: [], //列表数组
      hotList_arr: [], //热门列表
      searchText: "", //搜索内容
      is_more: true,
      is_loading: false,
      idloading: true,
      // seo
      keywords: "",
    };
  },

  computed: {},
  metaInfo() {
    return {
      meta: [
        { name: "keywords", content: this.keywords },
      ],
    };
  },
  components: {
    HeaderTop,
    Footer,
    hot,
    listLi,
    Hezuo
  },
  watch: {
    recommended_id: function (eve) {
      console.log(eve)
      this.$store.commit("setColumn", eve);
      this.page = 1;
      console.log('2222222222222222')
      this.getListcum();


    },
  },
  methods: {
    // seo 
    getSeo() {
      this.$get("seo").then((res) => {
        if (res.code == 200) {
          this.keywords = res.data[4];

        }
      });

    },
    judgeUser() {
      //判断用户数据
      if (this.USER() && this.USER() !== {}) {
        this.REFRESH_USER();
      } else {
        this.$refs.header.promptShow();
      }
    },
    searchFun(text) {
      this.searchText = text;
      this.page = 1;
      if (this.searchText) {
        this.getListcum();
      }

    },
    follow(type) {
      //1关注2取关
      this.judgeUser();
      let that = this;
      this.$post("follow", {
        conf_id: this.recommended_id,
        member_id: this.USER().id,
        type: type,
      }).then((res) => {
        that.recommended_arr[that.recommended_index].is_follow =
          that.recommended_arr[that.recommended_index].is_follow == 1 ? 0 : 1;
      });
    },
    recommendedFun(index) {
      //切换导航
      this.recommended_id = this.recommended_arr[index].conf_id;
      this.recommended_index = index;
    },
    detailsFun(id) {
      //查看详情

      this.$router.push({
        path: "/column_details",
        query: { id: id, head_index: 2 },
      });
    },
    details(id, record_url) {
      //跳转页面
      if (this._isMobile()) {
        // alert("手机端");
        if (this.selectBox_index == 1) {
          //直播
          //   this.$router.push({path: 'min_move',query:{ id:id,url:record_url}});
        } else {
          //   this.$router.push({path: 'min_record',query:{ id:id,url:record_url}});
        }
      } else {
        // alert("pc端");
        if (this.selectBox_index == 1) {
          //直播
          //   this.$router.push({path: 'pc_move',query:{ id:id,url:record_url}});
        } else {
          //   this.$router.push({path: 'pc_record',query:{ id:id,url:record_url}});
        }
      }
    },
    getListcum(id) {
      //获取列表数据
      let that = this;
      that.is_loading = false;

      if (this.page == 1) {
        this.list_arr = [];
      }
      this.$post("news_lists", {
        conf_id: id ? id : this.recommended_id,
        limit: 10,
        page: this.page,
        keyword: this.searchText,
      }).then((res) => {

        if (res.data.data.length <= 0) {
          that.is_more = false;
        } else {
          that.is_more = true;
        }
        that.list_arr = that.list_arr.concat(res.data.data);

        that.$nextTick(() => {
          that.$refs.listLi.videoFun();
        });
        that.is_loading = true;
      });
    },
    getNews() {
      //获取栏目
      let that = this;
      if (this.$route.query.id) {
        this.recommended_id = this.$route.query.id;
      }
      this.$get("news_conf", {
        page: 1,
        limit: 999,
        member_id: this.USER().id,
      }).then((res) => {

        that.recommended_arr = res.data.data;
        that.recommended_id = that.recommended_id
          ? that.recommended_id
          : that.recommended_arr[0].conf_id;
        that.recommended_arr.forEach((liem, index) => {
          if (that.recommended_id == liem.conf_id) {
            that.recommended_index = index;
          }
        });
      });
    },
    getHotList() {
      //获取热门列表数据
      let that = this;
      this.$post("news_recomm", {
        type: 4,
        limit: 10,
        page: 1,
      }).then((res) => {
        let data = res.data.data;
        that.hotList_arr = data;
      });
    },
    moreFun() {
      this.page++;
      this.getListcum();
    },
  },
  created() {


    this.idloading = true;
    // this.getSeo()
  },
  activated() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.idloading = false;
    let that = this;
    if (this.USER() && this.USER() !== {}) {
      this.REFRESH_USER();
    }
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
      setTimeout(() => {
        that.$refs.header.headerFun(this.searchText);
      }, 500);
    }
    document.title = "麻醉眼界";
    //  if (this.$route.query.id||this.$route.query.id===0) {
    //   this.list_arr = [];
    //   this.getListcum(this.$route.query.id);
    //   this.recommendedFun(0)
    //  }
    // } else {
    //   this.recommended_id = this.$store.state.column_id;
    //   this.getListcum()
    // }
    this.getNews();
    this.getHotList();
    // if (this._isMobile()) {
    //   // alert("手机端");
    //   this.$router.replace("/m_column");
    // } else {
    //   // alert("pc端");
    //   this.$router.replace('/column');
    // }

    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 2 >= scrollHeight) {
        that.page++;
        that.getListcum();
      }
    });

  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.idloading = false;
    let that = this;
    if (this.USER() && this.USER() !== {}) {
      this.REFRESH_USER();
    }
    if (this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
      setTimeout(() => {
        that.$refs.header.headerFun(this.searchText);
      }, 500);
    }
    document.title = "麻醉眼界";
    // console.log(this.$route.query.id,'3333333333333333');
    if (this.$route.query.id === 0) {
      this.list_arr = [];
      this.getListcum(this.$route.query.id);
      // this.recommendedFun(0)
    }
    // else {
    // this.recommended_id = this.$store.state.column_id;
    // console.log('111111111111111')
    // this.getListcum()
    // }
    this.getNews();
    this.getHotList();
    // if (this._isMobile()) {
    //   // alert("手机端");
    //   this.$router.replace("/m_column");
    // } else {
    //   // alert("pc端");
    //   this.$router.replace('/column');
    // }

    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 2 >= scrollHeight) {
        that.page++;
        that.getListcum();
      }
    });
  },
};
</script>
<style>
</style>
<style scoped>
@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
}

@keyframes configure-clockwise {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

@keyframes configure-xclockwise {
  0% {
    transform: rotate(45deg);
  }
  25% {
    transform: rotate(-45deg);
  }
  50% {
    transform: rotate(-135deg);
  }
  75% {
    transform: rotate(-215deg);
  }
  100% {
    transform: rotate(-305deg);
  }
}

@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0.25;
    transform: scale(0.75);
  }
}

/* GRID STYLING */

* {
  box-sizing: border-box;
}

body {
  min-height: 100vh;
  background-color: #37474f;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-start;
}

.spinner-box {
  width: 100%;
  height: 90vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
.spinner-box div {
  margin-top: 10px;
  font-size: 20px;
}
/* SPINNING CIRCLE */

.circle-border {
  width: 150px;
  height: 150px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: rgb(63, 249, 220);
  background: linear-gradient(
    0deg,
    rgba(63, 249, 220, 0.1) 33%,
    rgba(63, 249, 220, 1) 100%
  );
  animation: spin 0.8s linear 0s infinite;
}

.circle-core {
  width: 100%;
  height: 100%;
  background-color: #37474f;
  border-radius: 50%;
}

/* X-ROTATING BOXES */

.configure-border-1 {
  width: 115px;
  height: 115px;
  padding: 3px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffab91;
  animation: configure-clockwise 3s ease-in-out 0s infinite alternate;
}

.configure-border-2 {
  width: 115px;
  height: 115px;
  padding: 3px;
  left: -115px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(63, 249, 220);
  transform: rotate(45deg);
  animation: configure-xclockwise 3s ease-in-out 0s infinite alternate;
}

.configure-core {
  width: 100%;
  height: 100%;
  background-color: #37474f;
}

/* PULSE BUBBLES */

.pulse-container {
  width: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pulse-bubble {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #3ff9dc;
}

.pulse-bubble-1 {
  animation: pulse 0.4s ease 0s infinite alternate;
}
.pulse-bubble-2 {
  animation: pulse 0.4s ease 0.2s infinite alternate;
}
.pulse-bubble-3 {
  animation: pulse 0.4s ease 0.4s infinite alternate;
}

/* SOLAR SYSTEM */

.solar-system {
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.orbit {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ffffffa5;
  border-radius: 50%;
}

.earth-orbit {
  width: 165px;
  height: 165px;
  -webkit-animation: spin 12s linear 0s infinite;
}

.venus-orbit {
  width: 120px;
  height: 120px;
  -webkit-animation: spin 7.4s linear 0s infinite;
}

.mercury-orbit {
  width: 90px;
  height: 90px;
  -webkit-animation: spin 3s linear 0s infinite;
}

.planet {
  position: absolute;
  top: -5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #3ff9dc;
}

.sun {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #ffab91;
}
.main {
  max-width: 1280px;
  min-width: 865px;
  margin: 0 auto;
  width: 1280px;
  position: relative;
}

#index {
  background: #f5f3fb;
  min-width: 1280px;
}

.main {
  padding: 13px 0;
  align-items: flex-start;
}

/* 推荐导航 */
.recommended {
  width: 895px;
  background: #fff;
  border-radius: 10px;
}

.recommended .recommended_head {
  padding: 8px 20px 0 20px;
  border-bottom: 0.005rem solid #999999;
  white-space: normal;
  align-items: flex-start;
}

.recommended .recommended_head .recommended_title {
  flex: 1;
}

.recommended .recommended_title .recommended_title_li {
  margin-right: 6px;
  width: 18%;
  margin-bottom: 6px;
  font-size: 15px;
  cursor: pointer;
  color: #333;
  display: inline-flex;
}

.recommended .recommended_title .recommended_title_li.selected {
  position: relative;
  font-weight: bold;
}

.recommended .recommended_title .recommended_title_li.selected {
  color: #f24d5b;
  font-weight: bold;
}

.recommended .recommended_head .focus {
  width: 108px;
  height: 34px;
  border-radius: 4px;
  color: #fff;
  background: #f24d5b;
  font-size: 14px;
  border: 0;
}

.recommended .recommended_head .focus.no_focus {
  background: #ccc;
}

.liem_ul {
  padding-bottom: 40px;
  /* max-height: 100vh;
        overflow-y:auto; */
}

/* 热门 */
.hot {
  width: 334px;
  background: #fff;
  border-radius: 10px;
  /* position: fixed;
        right: calc((100% - 1280px) / 2);
        top: 74px; */
  position: absolute;
  right: 0;
  top: 13px;
}

.hot .hot_title {
  border-bottom: 0.005rem solid #999999;
}

.hot .hot_title > i {
  width: 15px;
  margin-right: 11px;
}

.hot .hot_title > span {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  height: 70px;
}
</style>


// WEBPACK FOOTER //
// src/components/pc_viwe/column.vue